import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIncognitoSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1423_6121)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.59266 14.7713C6.61896 14.7713 7.45094 13.9393 7.45094 12.913C7.45094 11.8867 6.61896 11.0547 5.59266 11.0547C4.56636 11.0547 3.73438 11.8867 3.73438 12.913C3.73438 13.9393 4.56636 14.7713 5.59266 14.7713Z",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.495 14.7713C13.5213 14.7713 14.3533 13.9393 14.3533 12.913C14.3533 11.8867 13.5213 11.0547 12.495 11.0547C11.4687 11.0547 10.6367 11.8867 10.6367 12.913C10.6367 13.9393 11.4687 14.7713 12.495 14.7713Z",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.45117 12.9141H10.6368",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.07959 8.93359H17.0077",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.20361 8.9311L6.47552 4.25885C6.52481 4.18803 6.59062 4.1303 6.66725 4.09065C6.74387 4.05099 6.82901 4.03061 6.91529 4.03127C7.00157 4.03192 7.08638 4.05359 7.1624 4.0944C7.23842 4.13521 7.30335 4.19393 7.35156 4.26548L8.59927 6.14367C8.64751 6.21762 8.71344 6.27837 8.79109 6.32042C8.86873 6.36247 8.95563 6.38449 9.04393 6.38449C9.13222 6.38449 9.21912 6.36247 9.29677 6.32042C9.37441 6.27837 9.44034 6.21762 9.48859 6.14367L10.7363 4.26548C10.7845 4.19393 10.8494 4.13521 10.9255 4.0944C11.0015 4.05359 11.0863 4.03192 11.1726 4.03127C11.2588 4.03061 11.344 4.05099 11.4206 4.09065C11.4972 4.1303 11.563 4.18803 11.6123 4.25885L14.8842 8.9311",
				stroke: "black",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1423_6121",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.99,
			height: 16.99,
			fill: "white",
			transform: "translate(0.548828 0.96875)"
		})
	}) })]
});
export default SvgIncognitoSymbol;
